import type { CanvasApiErrorParams } from '../types';

// Thrown by canvasRequest on any non-2xx response. Carries the domain `code`
// (CANVAS_NOT_FOUND, CANVAS_ACCESS_DENIED, VALIDATION_ERROR, ...) so the UI can
// map errors to toasts without parsing messages.
class CanvasApiError extends Error {
    code: string;

    status: number;

    details: Record<string, unknown> | null;

    constructor({ code, message, status, details }: CanvasApiErrorParams) {
        super(message);
        this.name = 'CanvasApiError';
        this.code = code;
        this.status = status;
        this.details = details;
    }
}

export default CanvasApiError;
